import {asyncActionGenerator} from 'utils';

export const feturedVideosAsyncActions = asyncActionGenerator('FEATURED')